
import { Component, Prop, Vue, Emit, Watch } from "vue-property-decorator";
import Auth from "@/lib/common/auth";
import DimensionEdit from "./dimension-edit.vue";
import { ExamV2Custom } from "@/lib/model/exambuilder/exam-v2";
import {
  QuestionV2,
  QuestionV2Object
} from "@/lib/model/exambuilder/question-v2";

import Dimensions, {
  DimensionRes,
  Dimension
} from "../../../lib/dimension/dimension";

import { getDimensionColor } from "../../../lib/dimension/dimension-color";
@Component({
  components: {
    DimensionEdit
  }
})
export default class DimensionSelect extends Vue {
  @Prop({ type: ExamV2Custom, default: null }) exam!: ExamV2Custom; //考试Model
  @Prop({ type: Array }) dimensionKeyList!: string[]; //数据已选
  @Prop({ type: Number, default: 12 }) maxDimensionCount!: number; //数据已选
  @Prop({ type: Array, default: null })
  examDimensionKeyList!: Array<any> | null; //考试中使用的维度，有值时表示编辑维度场景在某场考试中，不在考试维度中的项需要置灰
  @Prop({ type: Boolean, default: false }) disable!: boolean; //维度不可改
  @Prop({ type: Boolean, default: false }) isInDialog!: boolean; //是否在弹窗引用 1.维度可收起
  @Prop({ type: Boolean, default: false }) isEdit!: boolean; //是否编辑页面 默认收起维度名
  @Prop({ type: Boolean, default: true }) canEditDimension!: boolean; // 能否编辑自定义维度
  @Prop({ type: Boolean, default: true }) dimensionCanChange!: boolean; // 能否选择维度
  @Prop({ type: Number, default: 0 }) ignoreNoQuestionDimension!: number; // 是否滤掉没有题目的维度 1 是
  @Prop({
    type: Array,
    default: () => {
      return [];
    }
  })
  disabledDimList!: string[]; // 禁用维度
  @Prop({ type: Number, default: 0 }) industryId!: number; // 行业筛选
  @Prop({ type: Number, default: 0 }) positionId!: number; // 岗位筛选
  @Prop({ type: Boolean, default: false }) addExamQuery!: boolean; // 面试流程中添加参数

  @Watch("disabledDimList")
  eee(n: any, s: any) {
    //
  }

  show = false;
  dimensionList: Dimension[] = []; //所有维度
  dimensionListDiy: Dimension[] = []; //自定义维度
  dimensionListDef: Dimension[] = []; //标准维度
  dimensionListFromSystem: Dimension[] = []; // 历史公有维度保留 若为空则不展示
  selectedTagList: Dimension[] = []; //已选
  warnDimension = false;
  showWarn = false; //删除有单一维度题的维度
  dimensionToDel = new Dimension(); //待确认删除的维度
  questionToDelList: QuestionV2[] = []; //待删除题目
  delTitle = "";
  questionSelectedList: QuestionV2[] = []; //回滚使用 已选题目
  showMore = true; //维度展开
  dataReady = false;
  hasGroupEffect = false;

  @Watch("isEdit")
  cc() {
    this.showMore = this.isEdit ? false : true;
  }

  async created() {
    await this.getAll();
    this.onDimensionKeyListChange();
  }

  async mounted() {
    //
  }
  //所有维度 根据行业 岗位 筛选
  @Watch("industryId")
  @Watch("positionId")
  async getAll() {
    const p: any = {
      questionPositionIdList: this.positionId === 0 ? [] : [this.positionId],
      questionIndustryIdList: this.industryId === 0 ? [] : [this.industryId],
      ignoreNoQuestionDimension: this.ignoreNoQuestionDimension
    };
    if (this.addExamQuery) {
      p.isExamEnv = 1; // 历史面试数据兼容需求，写死1
      p.withExamId = this.exam.examId; // 历史面试数据兼容需求，传面试id
    }
    const res = await Dimensions.getAll(p);
    this.onLoadedDimensionList(res.list);
  }

  onLoadedDimensionList(list: any) {
    // 维度数据发生变动
    this.dimensionList = list;

    // 检测列表中的维度是否在考试中
    if (this.examDimensionKeyList) {
      for (const dim of this.dimensionList) {
        if (this.examDimensionKeyList.indexOf(dim.dimensionKey) == -1) {
          dim.notInExam = true;
        }
      }
    }

    // 过滤已经不存在的维度
    const selectedTagList: Dimension[] = [];
    this.selectedTagList.forEach(dim => {
      this.dimensionList.forEach((d: Dimension) => {
        if (dim.dimensionKey === d.dimensionKey) {
          selectedTagList.push(d);
        }
      });
    });
    const dimensionDeleted =
      this.selectedTagList.length != selectedTagList.length;
    this.selectedTagList = selectedTagList;
    if (dimensionDeleted) {
      // 因为有可能有些维度被删除了，所以需要通知父级接收
      this.$emit("checkDimension", this.selectedTagList);
    }
    // 将维度数据拆分成两个列表， 新增历史数据的列表
    //自定义维度
    this.dimensionListDiy = this.dimensionList.filter(
      (d: Dimension) =>
        d.isSystemDimension !== 1 && d.isFromSystemDimension !== 1
    );
    //标准维度
    this.dimensionListDef = this.dimensionList.filter(
      (d: Dimension) =>
        d.isSystemDimension === 1 && d.isFromSystemDimension !== 1
    );
    // 历史公有维度保留
    this.dimensionListFromSystem = this.dimensionList.filter(
      (d: Dimension) => d.isFromSystemDimension === 1
    );
    this.setChecked();

    for (const dim of this.selectedTagList) {
      if (
        this.examDimensionKeyList &&
        this.examDimensionKeyList.indexOf(dim.dimensionKey) == -1
      ) {
        dim.notInExam = true;
      }
    }
    this.dataReady = true;
  }

  //回显
  @Watch("dimensionKeyList", { immediate: true })
  onDimensionKeyListChange(to: any = null, from: any = null) {
    // 外部输入数据变动，重新生成selectedTagList
    this.selectedTagList = [];
    this.dimensionKeyList.forEach(id => {
      this.dimensionList.forEach((d: Dimension) => {
        if (id === d.dimensionKey) {
          this.selectedTagList.push(d);
        }
      });
    });
    this.setChecked();
  }
  setChecked() {
    // 这个函数只负责把selectedTagList的数据渲染到界面（即设置该项checked)
    // 不要在这个函数内修改selectedTagList！！！！！
    // 此函数具有幂等性，调几次现象都保持一致，请勿添加破坏幂等性的代码
    this.dimensionListDiy.forEach((d: Dimension) => {
      d.checked = false;
    });
    this.dimensionListDef.forEach((d: Dimension) => {
      d.checked = false;
    });
    this.dimensionListFromSystem.forEach((d: Dimension) => {
      d.checked = false;
    });

    this.selectedTagList.forEach(dim => {
      this.dimensionListDiy.forEach((d: Dimension) => {
        if (dim.dimensionKey === d.dimensionKey) {
          d.checked = true;
        }
      });
      this.dimensionListDef.forEach((d: Dimension) => {
        if (dim.dimensionKey === d.dimensionKey) {
          d.checked = true;
        }
      });
      this.dimensionListFromSystem.forEach((d: Dimension) => {
        if (dim.dimensionKey === d.dimensionKey) {
          d.checked = true;
        }
      });
    });
  }
  //选择某项
  selectItem(item: Dimension) {
    if (this.disabledDimList.includes(item.dimensionName)) {
      //禁用维度
      return;
    }
    if (
      this.selectedTagList.length >= this.maxDimensionCount &&
      item.checked === false
    ) {
      this.$message.warning("最多可选" + this.maxDimensionCount + "个维度");
      return;
    }
    //回滚时 取消选中
    if (
      item.checked &&
      this.exam &&
      this.exam.questionIdList &&
      this.exam.questionIdList.length &&
      this.exam.questionIdList[0] !== 0
    ) {
      this.queryQuestion(item);
      return;
    }
    this.setIfSelected(item);
  }
  //选中or取消 --更新维度list
  setIfSelected(item: Dimension) {
    if (this.disable) return;
    item.checked = !item.checked;
    if (item.checked) {
      this.selectedTagList.push(item);
    } else {
      for (let i = 0; i < this.selectedTagList.length; i++) {
        if (this.selectedTagList[i].dimensionKey == item.dimensionKey) {
          this.selectedTagList.splice(i, 1);
          break;
        }
      }
    }

    this.$emit("checkDimension", this.selectedTagList);
    if (item.checked) {
      this.warnDimension = false;
    }
    if (!item.checked) {
      this.onCancelCheck(item);
    }
  }

  checkData() {
    this.warnDimension = true;
  }
  showDimensionEdit() {
    this.show = true;
  }
  //查各题目下维度情况
  async queryQuestion(item: Dimension) {
    //更新已选题目 下的维度
    const t = await this.getQuestionList();
    this.questionSelectedList = t.list;
    let flag = true;
    this.questionToDelList = [];
    for (const q of this.questionSelectedList) {
      //单一维度题 需二次确认后 删题 删维度
      if (
        q.dimensionListFilter.length === 1 &&
        q.dimensionListFilter[0].dimensionKey === item.dimensionKey
      ) {
        this.questionToDelList.push(q);
        flag = false;
      }
    }
    if (flag) {
      //多维度直接删维度
      this.setIfSelected(item);
    } else {
      //二次确认
      if (this.exam.isRandomQuestions === 1) {
        this.questionToDelList.forEach(el => {
          const effectGroup = this.checkGroupEffect(el.questionId);
          if (effectGroup) {
            this.hasGroupEffect = true;
          }
        });
      }
      this.delTitle = item.dimensionName;
      this.dimensionToDel = item; //当前待删维度
      this.showWarn = !flag;
    }
  }

  // 检查是否影响到了抽题组
  checkGroupEffect(questionId: number) {
    let flag: any = false;
    this.exam.examRandomConfigList.forEach(el => {
      if (el.questionIdList.includes(questionId)) {
        flag = el;
      }
    });
    return flag;
  }

  // 删除影响到的抽题组
  catchGroupEffect(questionId: number) {
    console.log(this.dimensionToDel);
    const effectGroup = this.exam.examRandomConfigList.filter(el =>
      el.questionIdList.includes(questionId)
    );
    const index = this.exam.examRandomConfigList.findIndex(el =>
      el.questionIdList.includes(questionId)
    );
    if (effectGroup.length > 0) {
      const item = effectGroup[0];
      console.log(JSON.parse(JSON.stringify(item)));
      if (item.questionIdList.length === 1) {
        // 最后一道题
        this.exam.examRandomConfigList.splice(index, 1);
      } else if (item.questionIdList.length === item.questionNumber) {
        // 影响抽题数量
        this.exam.examRandomConfigList.forEach((el, index) => {
          if (index === index) {
            el.questionIdList = el.questionIdList.filter(
              el => el !== questionId
            );
            el.questionList = el.questionList.filter(
              el => el.questionId !== questionId
            );
            el.questionNumber = el.questionNumber - 1;
          }
        });
      } else {
        this.exam.examRandomConfigList.forEach((el, index) => {
          if (index === index) {
            el.questionIdList = el.questionIdList.filter(
              el => el !== questionId
            );
            el.questionList = el.questionList.filter(
              el => el.questionId !== questionId
            );
          }
        });
      }
    }
  }
  //二次确认后 同时删除 题idList 和 维度list
  deleteQuestion() {
    const t: QuestionV2[] = []; //要保留的题
    const k: number[] = []; //要保留的题key
    this.questionSelectedList.forEach((q: QuestionV2) => {
      //指定的单一维度题 删掉
      if (
        !(
          q.dimensionListFilter.length === 1 &&
          q.dimensionListFilter[0].dimensionKey ===
            this.dimensionToDel.dimensionKey
        )
      ) {
        t.push(q);
        k.push(q.questionId);
      }
    });
    if (this.exam.isRandomQuestions === 1) {
      this.questionToDelList.forEach(el => {
        const effectGroup = this.checkGroupEffect(el.questionId);
        if (effectGroup) {
          this.catchGroupEffect(el.questionId);
        }
      });
      const index = this.exam.dimensionLevelList.findIndex(
        el => el.dimensionKey === this.dimensionToDel.dimensionKey
      );
      this.exam.dimensionLevelList.splice(index, 1);
    }
    this.setIfSelected(this.dimensionToDel); //同时删下维度
    this.questionSelectedList = t;
    this.exam.questionIdList = k; //已删后的题idList
    //同时去掉题目对应配置list 和 分数list
    for (let i = 0; i < this.exam.examQuestionConfigList.length; i++) {
      if (
        !this.exam.questionIdList.includes(
          this.exam.examQuestionConfigList[i].questionId
        )
      ) {
        this.exam.examQuestionConfigList.splice(Number(i), 1);
        i--;
      }
    }
    for (let i = 0; i < this.exam.examScoreConfigList.length; i++) {
      if (
        !this.exam.questionIdList.includes(
          this.exam.examScoreConfigList[i].questionId
        )
      ) {
        this.exam.examScoreConfigList.splice(Number(i), 1);
        i--;
      }
    }
    this.showWarn = false;
    console.log(this.exam);
    this.change();
  }
  //更新已选题目list
  async getQuestionList() {
    const param = {
      questionIdList: this.exam?.questionIdList,
      dimensionKeyFilterList: this.exam?.dimensionKeyList
    };
    return await QuestionV2Object.get(param);
  }

  dontDel() {
    this.showWarn = false;
  }
  update() {
    this.getAll();
  }
  changeMore() {
    if (this.isInDialog && this.dimensionCanChange) {
      this.showMore = !this.showMore;
    }
  }

  @Emit()
  change() {
    return;
  }

  @Emit("onCancelCheck")
  onCancelCheck(item: Dimension) {
    return item.dimensionKey;
  }
}
